module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-42.a3eccfcd.png";